import { compareStr } from '@/plugins/utils'

export default {
  surcommissionsConfigs: (state) => state.configs,
  surcommissionConfigByYear: (state) => (annee) =>
    state.configs &&
    state.configs.find((model) => compareStr(model.getAnnee())(annee)),
  surcommissionsConfigs_pending: (state) => state.configs_pending
}
